import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwaySemiSenior() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Semi Senior",
        level: 3,
        subtitle: "2+ a\u00f1os de trayectoria equiparable",
        emoji: "\ud83e\udd86",
        color: "yellow",
        description:
          "Desarrollador con buen nivel de autonom\u00eda, que puede desarrollar gran parte del trabajo que se presenta en los proyectos sin mayor asistencia.",
        sections: [
          {
            title: "Autonom\u00eda",
            color: "yellow",
            icon: "\ud83d\udc64",
            content:
              "Desarrollador aut\u00f3nomo capaz de manejar la mayor\u00eda de las tareas de los proyectos con m\u00ednima asistencia. Su nivel de autonom\u00eda le permite el correcto manejo de situaciones de cara al cliente y dentro del equipo buscando si es necesario ayuda para derivar al lugar/persona que pueda gestionar. Manejan tareas de complejidad media y baja y participan activamente en tareas complejas, aunque pueden necesitar ayuda.",
          },
          {
            title: "Cultura Organizacional",
            color: "green",
            icon: "\ud83d\udc65",
            content:
              "Interiorizados con la cultura y los valores de Silver, aplic\u00e1ndolos diariamente. Contribuidores individuales fuertes que est\u00e1n comenzando a extender sus habilidades para ayudar a sus compa\u00f1eros.",
          },
          {
            title: "Especializaci\u00f3n T\u00e9cnica",
            color: "purple",
            icon: "\ud83d\udcbb",
            content:
              "Competentes en alg\u00fan lenguaje, framework o tecnolog\u00eda, pero requieren desarrollo adicional para profundizar la especializaci\u00f3n. Tienen alguna herramienta con la que tienen una familiaridad superior al promedio de sus compa\u00f1eros.",
          },
          {
            title: "Feedback y Evaluaci\u00f3n",
            color: "blue",
            icon: "\ud83d\udcac",
            content:
              "Se cuestionan, eval\u00faan situaciones y se retroalimentan de otros, aprendiendo de cada situaci\u00f3n que se le presenta. Enfocados principalmente en su crecimiento individual.",
          },
          {
            title: "Relaci\u00f3n con el Cliente",
            color: "blue",
            icon: "\ud83e\udd1d",
            content: [
              "Crean lazos de confianza.",
              "Participan activamente en ceremonias (Ej: Ayudando a refinar requerimientos con el PO).",
              "Interact\u00faan a distintos niveles con el cliente (POs/PMs, devs del cliente, stakeholders).",
            ],
          },
          {
            title: "Colaboraci\u00f3n y Buenas Pr\u00e1cticas",
            color: "green",
            icon: "\ud83d\udccb",
            content: [
              "Enriquecen pull requests con comunicaci\u00f3n fluida, detectando mejoras y abiertos al feedback constantemente.",
              "Aplican buenas pr\u00e1cticas en codificaci\u00f3n y tests automatizados.",
              "Conocimientos s\u00f3lidos en Git, pudiendo resolver con soltura todos los problemas que se presentan.",
              "Velocidad de desarrollo sostenida para tareas de complejidad y tama\u00f1o intermedio-alto.",
            ],
          },
        ],
        observableBehaviors: [
          "El intercambio en pull requests es bastante rico. Suele generar ideas que enriquecen las soluciones de los dem\u00e1s, y es capaz de encontrar errores o oportunidades de mejora cuando \u00e9stas son de dificultad simple o media.",
          "Conoce y aplica buenas pr\u00e1cticas en la codificaci\u00f3n de tests automatizados, incluyendo algunos conceptos b\u00e1sicos.",
          "Tiene un manejo adecuado de git, pudiendo resolver con soltura todas las manipulaciones que se presenten en cuanto a las branches de un proyecto.",
          "Tiene una velocidad de desarrollo sostenida para features de complejidad y tama\u00f1o intermedio alto. En esos casos si hay cosas que no fueron previstas u otros motivos que cambian la estimaci\u00f3n, puede comunicarlo al equipo y cliente con soltura.",
          "Puede trabajar en spikes o planificar una \u00e9pica (dividirla en stories) de forma aut\u00f3noma siempre y cuando la complejidad sea intermedia o baja.",
        ],
        deepDive: [
          "Es capaz de trabajar con alto nivel de autonom\u00eda muchas de las tareas que se hacen en los proyectos, especialmente las de complejidad media y baja.",
          "Sigue siendo productivo especialmente en su track individual, pero ocasionalmente puede desdoblarse para ayudar con el resto del equipo, en las situaciones en que sea obvio que esto es para obtener mejores resultados en lo grupal.",
          "Participan activamente de tareas m\u00e1s complejas, como pueden ser features grandes, spike t\u00e9cnicas, cambios en infraestructura, investigaci\u00f3n de problemas en producci\u00f3n, pero generalmente a\u00fan precisan ayuda para completar o hacer un correcto seguimiento del trabajo en estos casos.",
          "Pueden generar lazos con la gente del lado cliente, llegando a ganarse la confianza de los mismos. Empiezan a generar valor que se percibe y aprecia por el cliente.",
          "Detectan cuando hay requerimientos que necesitan ser refinados, y pueden hacer contribuciones \u2014 con el PO \u2014 en ese sentido.",
          "Son capaces de navegar el proyecto o la soluci\u00f3n t\u00e9cnica con soltura, aunque haya partes que comprendan m\u00e1s que otras.",
          "Tienen opiniones sobre el estado de la deuda t\u00e9cnica pero pueden necesitar ayuda para pensar en planes para mitigarla.",
          "Su participaci\u00f3n en reuniones con gente del lado cliente es completa, logra participar y aportar como si se tratase de una reuni\u00f3n solo con gente de la organizaci\u00f3n.",
          "Tiene autonom\u00eda y capacidad para determinar el tipo de interacciones con clientes que se necesiten en diversos casos.",
          "Contribuye a nivel de equipo, y un poco m\u00e1s. Ya domina su parte en el proyecto, por lo que su foco de contribuci\u00f3n aumenta en amplitud.",
        ],
        evolution: {
          title: "Evoluci\u00f3n hacia Senior",
          items: [
            {
              title: "Enfoque en el Equipo",
              points: [
                "Importancia de estar atento a las necesidades de los compa\u00f1eros y del equipo. Realizar muchos CRs, mucho pairing, estar al tanto de la totalidad del proyecto.",
              ],
            },
            {
              title: "Crecimiento Tecnol\u00f3gico",
              points: [
                "Significativo crecimiento en determinada \u00e1rea espec\u00edfica. Presenta la habilidad de explicar claramente un problema que se le presenta, las soluciones intentadas y las necesidades espec\u00edficas.",
              ],
            },
            {
              title: "Liderazgo",
              points: [
                "Comienzan a liderar, tomando iniciativas propias importantes. Alguien que puede inspirar y motivar a los dem\u00e1s a trabajar juntos para alcanzar los objetivos comunes.",
              ],
            },
          ],
        },
        prev: { name: "Anterior: Advanced", url: "/growth/career-pathway/advanced" },
        next: { name: "Siguiente: Senior", url: "/growth/career-pathway/senior" },
      }}
    />
  )
}

CareerPathwaySemiSenior.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
